// import mutations from './mutations'
// import actions from './actions'
// import moment from 'moment';
import { Backend } from '@/_axios';

export const LOAD_GROUPS = 'LOAD_GROUPS';
export const SET_GROUPS = 'SET_GROUPS';

export const SET_ACTIVE_USERS_GROUP = 'SET_ACTIVE_USERS_GROUP';

export const LOAD_ACTIVE_USERS_GROUP = 'LOAD_ACTIVE_USERS_GROUP';
export const SET_LOADED_ACTIVE_USERS_GROUP = 'SET_LOADED_ACTIVE_USERS_GROUP';
export const SET_CHANGED_ACTIVE_USERS_GROUP = 'SET_CHANGED_ACTIVE_USERS_GROUP';
export const SET_CHANGED_ACTIVE_USERS_GROUP_ERROR = 'SET_CHANGED_ACTIVE_USERS_GROUP_ERROR';

const state = {
  groups: {},
  activeUsersGroup: {},
  groupNotification: {
    message: '',
    status: 'loading',
    data: {}
  }
};

const getters = {
  groups: (state) => {
    return state.groups;
  },
  activeUsersGroup: (state) => {
    return state.activeUsersGroup;
  },
  groupNotification: (state) => {
    return state.groupNotification;
  }
};

const actions = {
  [LOAD_GROUPS]: function ({ commit }) {
    Backend.get('/api/groups').then((response) => {
      const groups = {};
      response.data.forEach((group) => {
        groups[group.id] = group;
      });
      commit('SET_GROUPS', { groups: groups });
    });
  },
  [SET_ACTIVE_USERS_GROUP]: function ({ commit }, { groupId }) {
    Backend.post('/api/set-active-users-group', { groupId: groupId }).then((response) => {
      commit('SET_CHANGED_ACTIVE_USERS_GROUP', { group: response.data.data.data, message: response.data.data.message });
    }, (err) => {
      console.log(err.response.data.message);
      commit('SET_CHANGED_ACTIVE_USERS_GROUP_ERROR', { message: err.response.data.message });
    });
  },
  [LOAD_ACTIVE_USERS_GROUP]: function ({ commit }) {
    Backend.get('/api/load-active-users-group').then((response) => {
      commit('SET_LOADED_ACTIVE_USERS_GROUP', { group: response.data });
    }, (err) => {

    });
  }

};

const mutations = {
  [SET_GROUPS]: function (state, { groups }) {
    state.groups = groups;
  },
  [SET_LOADED_ACTIVE_USERS_GROUP]: function (state, { group }) {
    state.activeUsersGroup = group;
  },
  [SET_CHANGED_ACTIVE_USERS_GROUP]: function (state, { group, message }) {
    state.groupNotification = {
      data: group,
      message: message,
      status: 'success'
    };
  },
  [SET_CHANGED_ACTIVE_USERS_GROUP_ERROR]: function (state, { message }) {
    for (const i in message) {
      state.groupNotification = {
        data: {},
        message: message[i],
        status: 'error'
      };
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
